module.exports = __webpack_public_path__ + "img/icon-drag-n-drop-default.d0674d9e.svg";